import { Dialog as RD } from 'radix-ui';
import { cn } from '@/lib/cn';
import type { ModalProps } from './Dialog';

/** The same header/body/footer, anchored to the bottom edge for phones. */
export function Sheet({ open, onOpenChange, title, description, children, footer, className }: ModalProps) {
  return (
    <RD.Root open={open} onOpenChange={onOpenChange}>
      <RD.Portal>
        <RD.Overlay className="fixed inset-0 z-40 bg-[rgba(23,23,26,.18)]" />
        <RD.Content className={cn('fixed z-50 inset-x-0 bottom-0 max-h-[88dvh] overflow-y-auto rounded-t-[18px] border-t border-border bg-card shadow-[0_-8px_40px_rgba(0,0,0,.18)] outline-none', className)}>
          <div className="px-5 pt-3">
            <div aria-hidden="true" className="mx-auto mb-4 h-1 w-10 rounded-pill bg-toggle-off" />
            <RD.Title className="text-[19px] font-extrabold tracking-[-.02em] m-0">{title}</RD.Title>
            {description && <RD.Description className="text-[13px] font-semibold text-ink-2 m-0 mt-[3px]">{description}</RD.Description>}
          </div>
          <div className="px-5 pt-5 pb-5">{children}</div>
          {footer && <div className="flex justify-end gap-[10px] px-5 py-4 border-t border-header-rule bg-canvas pb-[max(16px,env(safe-area-inset-bottom))]">{footer}</div>}
        </RD.Content>
      </RD.Portal>
    </RD.Root>
  );
}
